import { render, staticRenderFns } from "./MarketingCampaignManagement.vue?vue&type=template&id=2526d074&scoped=true"
import script from "./MarketingCampaignManagement.vue?vue&type=script&lang=ts"
export * from "./MarketingCampaignManagement.vue?vue&type=script&lang=ts"
import style0 from "./MarketingCampaignManagement.vue?vue&type=style&index=0&id=2526d074&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2526d074",
  null
  
)

export default component.exports